import "@hotwired/turbo-rails";
import { Turbo } from "@hotwired/turbo-rails";
import TurboPower from "turbo_power";

import "./controllers";
import "chartkick/chart.js";
import { Chart, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartjsPluginStacked100 from "chartjs-plugin-stacked100";
import gradient from "chartjs-plugin-gradient";
import PieChartOutLabels from "@donaldmckendrick/chartjs-plugin-piechart-outlabels";
import annotationPlugin from "chartjs-plugin-annotation";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import { draw } from "patternomaly";

const getOrCreateLegendList = (chart, id) => {
  // console.log('getting or creating legend list', id);
  const legendContainer = document.getElementById(id);
  let listContainer = legendContainer.querySelector(`ul#${id}-group`);

  if (!listContainer) {
    listContainer = document.createElement("ul");
    listContainer.id = `${id}-group`;
    listContainer.style.display = "flex";
    listContainer.style.flexDirection = "row";
    listContainer.style.margin = 0;
    listContainer.style.padding = 0;

    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};

const getOrCreateStackLegendList = (chart, id) => {
  // console.log('getting or creating legend list', id);
  const legendContainer = document.getElementById(id);
  let listContainer = legendContainer.querySelector(`ul#${id}-stack`);

  if (!listContainer) {
    listContainer = document.createElement("ul");
    listContainer.id = `${id}-stack`;
    listContainer.style.display = "flex";
    listContainer.style.flexDirection = "row";
    listContainer.style.margin = 0;
    listContainer.style.padding = 0;

    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};

const htmlLegendPlugin = {
  id: "htmlLegend",
  afterUpdate(chart, args, options) {
    // console.log('updating legend');
    if (!options.containerID) {
      return;
    }
    const stackUl = getOrCreateStackLegendList(chart, options.containerID);
    const ul = getOrCreateLegendList(chart, options.containerID);

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }
    while (stackUl.firstChild) {
      stackUl.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);
    const stacks = [];

    items.forEach((item) => {
      const originalLabel = item.text;
      let stackLabel = item.text;
      // get the text of the item and split on the first colon and take the first part
      if (stackLabel.includes(":")) {
        stackLabel = stackLabel.split(":")[0];
        item.text = stackLabel;
      }

      //  if stacks contains the stack, skip adding this legend item
      if (stacks.includes(stackLabel)) {
        item.text = originalLabel;
        return;
      }
      // if stacks does not contain the stack, add it to the end of the array
      stacks.push(stackLabel);

      // console.log('adding legend item', item);
      const li = document.createElement("li");
      li.style.alignItems = "center";
      li.style.cursor = "pointer";
      li.style.display = "flex";
      li.style.flexDirection = "row";
      li.style.marginLeft = "10px";

      li.onclick = () => {
        const { type } = chart.config;
        if (type === "pie" || type === "doughnut") {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          // chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // Color box
      const boxSpan = document.createElement("span");
      boxSpan.style.background = item.fillStyle;
      boxSpan.style.borderColor = item.strokeStyle;
      boxSpan.style.borderWidth = item.lineWidth + "px";
      boxSpan.style.display = "inline-block";
      boxSpan.style.flexShrink = 0;
      boxSpan.style.height = "20px";
      boxSpan.style.marginRight = "10px";
      boxSpan.style.width = "20px";

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = item.fillStyle;
      ctx.strokeStyle = item.strokeStyle;
      ctx.lineWidth = item.lineWidth;
      ctx.fillRect(0, 0, 20, 20);
      ctx.strokeRect(0, 0, 20, 20);

      // add the canvas to the boxSpan
      boxSpan.appendChild(canvas);

      // Text
      const textContainer = document.createElement("p");
      textContainer.style.color = item.fontColor;
      textContainer.style.margin = 0;
      textContainer.style.padding = 0;
      textContainer.style.textDecoration = item.hidden ? "line-through" : "";

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      stackUl.appendChild(li);
      item.text = originalLabel;
    });

    items.forEach((item) => {
      let stackLabel = item.text;
      // get the text of the item and split on the first colon and take the first part
      if (stackLabel.includes(":")) {
        stackLabel = stackLabel.split(":")[1];
        item.text = stackLabel;
      }

      //  if stacks contains the stack, skip adding this legend item
      if (stacks.includes(stackLabel)) {
        return;
      }
      // if stacks does not contain the stack, add it to the end of the array
      stacks.push(stackLabel);

      // console.log('adding legend item', item);
      const li = document.createElement("li");
      li.style.alignItems = "center";
      li.style.cursor = "pointer";
      li.style.display = "flex";
      li.style.flexDirection = "row";
      li.style.marginLeft = "10px";

      li.onclick = () => {
        const { type } = chart.config;
        if (type === "pie" || type === "doughnut") {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          // chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // Color box
      const boxSpan = document.createElement("span");
      boxSpan.style.background = item.fillStyle;
      boxSpan.style.borderColor = item.strokeStyle;
      boxSpan.style.borderWidth = item.lineWidth + "px";
      boxSpan.style.display = "inline-block";
      boxSpan.style.flexShrink = 0;
      boxSpan.style.height = "20px";
      boxSpan.style.marginRight = "10px";
      boxSpan.style.width = "20px";

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = item.fillStyle;
      ctx.strokeStyle = item.strokeStyle;
      ctx.lineWidth = item.lineWidth;
      ctx.fillRect(0, 0, 20, 20);
      ctx.strokeRect(0, 0, 20, 20);

      // add the canvas to the boxSpan
      boxSpan.appendChild(canvas);

      // Text
      const textContainer = document.createElement("p");
      textContainer.style.color = item.fontColor;
      textContainer.style.margin = 0;
      textContainer.style.padding = 0;
      textContainer.style.textDecoration = item.hidden ? "line-through" : "";

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      ul.appendChild(li);
    });
  },
};

TurboPower.initialize(Turbo.StreamActions);
Chart.register(ChartDataLabels);
Chart.register(ChartjsPluginStacked100);
Chart.register(gradient);
Chart.register(PieChartOutLabels);
Chart.register(annotationPlugin);
Chart.register(MatrixController, MatrixElement);
Chart.register(htmlLegendPlugin);
Tooltip.positioners.top = function (items) {
  const pos = Tooltip.positioners.average(items);

  // Happens when nothing is found
  if (pos === false) {
    return false;
  }

  const chart = this.chart;

  return {
    x: pos.x,
    y: chart.chartArea.bottom,
    xAlign: "center",
    yAlign: "top",
  };
};

Turbo.StreamActions.my_push_state = function () {
  const url = this.getAttribute("url");
  const state = {
    turbo_stream_history: true,
  };
  Turbo.cache.exemptPageFromPreview();
  history.replaceState(state, "", window.location.href);
  history.pushState(state, "", url);
};

Turbo.StreamActions.unsafe_turbo_frame_reload = function () {
  this.targetElements.forEach((element) => {
    if (
      element.src === undefined ||
      element.src === null ||
      element.src === ""
    ) {
      element.src = window.location.href;
    } else {
      element.reload();
    }
  });
};

Turbo.StreamActions.unsafe_inner_turbo_frame_reload = function () {
  this.targetElements.forEach((element) => {
    if (
      element.src === undefined ||
      element.src === null ||
      element.src === ""
    ) {
      element.src = element.closest("turbo-frame#sidebar").src;
    } else {
      element.reload();
    }
  });
};

window.addEventListener("popstate", (event) => {
  if (event.state && event.state.turbo_stream_history) {
    Turbo.visit(window.location.href, { action: "replace" });
  }
});

window.addEventListener("turbo:before-stream-render", (event) => {
  if (document.startViewTransition) {
    const originalRender = event.detail.render;
    event.detail.render = (currentElement, newElement) => {
      if (currentElement?.outerHTML?.includes("skip-view-transition")) {
        return originalRender(currentElement, newElement);
      }
      document.startViewTransition(() =>
        originalRender(currentElement, newElement),
      );
    };
  }
});

// function afterPrint () {
//   for (const id in Chart.instances) {
//     Chart.instances[id].resize()
//   }
// }
// function beforePrint() {
//   for (const id in Chart.instances) {
//     Chart.instances[id].resize(600, 600);
//   }
// }

// if (window.matchMedia) {
//   let mediaQueryList = window.matchMedia('print')
//   mediaQueryList.addListener((mql) => {
//     if (mql.matches) {
//       beforePrint()
//     }
//   })
// }

// window.onbeforeprint = beforePrint
// window.onafterprint = beforePrint

window.addEventListener("beforeprint", () => {
  for (const id in Chart.instances) {
    Chart.instances[id].resize();
  }
});

window.addEventListener("afterprint", () => {
  for (const id in Chart.instances) {
    Chart.instances[id].resize();
  }
});

import "trix";
import "@rails/actiontext";
